export const font = {
  size: {
    display1: '5.7rem', // 57px - Display Large
    display2: '4.5rem', // 45px - Display Medium
    display3: '3.6rem', // 36px - Display Small
    headline1: '3.2rem', // 32px - Headline Large
    headline2: '2.8rem', // 28px - Headline Medium
    headline3: '2.4rem', // 24px - Headline Small
    title1: '2.2rem', // 22px - Title Large
    title2: '2.0rem', // 20px - Title Largish
    title3: '1.6rem', // 16px - Title Medium
    title4: '1.4rem', // 14px - Title Small
    label1: '1.4rem', // 14px - Label Large
    label2: '1.2rem', // 12px - Label Medium
    label3: '1.1rem', // 11px - Label Small
    body1: '1.8rem', // 18px - Body Larger
    body2: '1.6rem', // 16px - Body Large
    body3: '1.4rem', // 14px - Body Medium
    body4: '1.2rem', // 12px - Body Small
  },
  lineHeight: {
    display1: '6.4rem', // 64px - Display Large
    display2: '5.2rem', // 52px - Display Medium
    display3: '4.4rem', // 44px - Display Small
    headline1: '4.0rem', // 40px - Headline Large
    headline2: '3.6rem', // 36px - Headline Medium
    headline3: '3.2rem', // 32px - Headline Small
    title1: '2.8rem', // 28px - Title Large
    title2: '2.8rem', // 28px - Title Largish
    title3: '2.4rem', // 24px - Title Medium
    title4: '2.0rem', // 20px - Title Small
    label1: '2.0rem', // 20px - Label Large
    label2: '1.6rem', // 16px - Label Medium
    label3: '1.6rem', // 16px - Label Small
    body1: '2.8rem', // 28px - Body Larger
    body2: '2.4rem', // 24px - Body Large
    body3: '2.0rem', // 20px - Body Medium
    body4: '1.6rem', // 16px - Body Small
  },
  letterSpacing: {
    xxl: '0.05rem', // 0.5px
    xl: '0.04rem', // 0.4px
    lg: '0.025rem', // 0.25px
    md: '0.015rem', // 0.15px
    sm: '0.01rem', // 0.1px
    none: '0', // 0px
  },
  weight: {
    bold: 700,
    regular: 400,
    light: 300,
  },
  family: {
    display: 'Affix',
    headline: 'Moderat',
    title: 'Moderat',
    label: 'Moderat',
    body: 'Moderat',
    input: '"Noto Sans", Moderat, sans-serif',
  },
};
